import { useEffect } from "react";
import Lenis from "lenis";

/**
 * Global Lenis momentum-scroll provider.
 * Also intercepts in-page anchor clicks (e.g. #teachers) so they respect Lenis easing.
 */
export default function SmoothScroll() {
    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.15,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
            wheelMultiplier: 1,
            touchMultiplier: 1.4,
        });

        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);

        // Route hash-anchor clicks through Lenis for buttery jumps
        const handleAnchorClick = (e) => {
            const link = e.target.closest('a[href^="#"]');
            if (!link) return;
            const hash = link.getAttribute("href");
            if (!hash || hash === "#") return;
            const target = document.querySelector(hash);
            if (!target) return;
            e.preventDefault();
            lenis.scrollTo(target, { offset: -72, duration: 1.4 });
        };
        document.addEventListener("click", handleAnchorClick);

        return () => {
            document.removeEventListener("click", handleAnchorClick);
            cancelAnimationFrame(rafId);
            lenis.destroy();
        };
    }, []);

    return null;
}
